import styled, { css } from 'styled-components'

import { Icon } from '@/components/ui/icon'

export const NavbarWrapper = styled.div(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.space['16'],
  justifyContent: 'space-between',
}))

export const CaretIcon = styled(Icon)<{ $isOpen: boolean }>(
  ({ theme, $isOpen }) => css`
    transform: ${$isOpen ? 'rotate(0deg)' : 'rotate(180deg)'};
    transition: transform ${theme.transition.duration.sm} ease;
  `,
)

export const VerticalSeparator = styled.div(({ theme }) => ({
  alignSelf: 'stretch',
  background: theme.colors.gray600,
  width: theme.border.size['1'],
}))
